import { render, staticRenderFns } from "./text-box.vue?vue&type=template&id=60249bfb"
import script from "./text-box.vue?vue&type=script&lang=js"
export * from "./text-box.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports